import { db } from '../firebase';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Send contact form enquiry to Firestore in the bookingEnquiries collection
 * Uses the same structure as booking enquiries but with a contact type tag
 */
export const sendContactEnquiry = async (enquiryData) => {
  try {
    // Generate a unique ID for the enquiry with "contact" prefix
    const enquiryId = `contact_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
    
    // Get current date info for structuring
    const now = new Date();
    const year = now.getFullYear().toString();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 01-12
    const date = now.getDate().toString().padStart(2, '0'); // 01-31
    
    // Add server timestamp, enquiry ID, and contact type indicator
    const dataWithTimestamp = {
      ...enquiryData,
      createdAt: serverTimestamp(),
      enquiryId: enquiryId,
      status: 'new', // Default status for new enquiries
      type: 'contact', // Identify this as a contact form submission
      propertyId: null, // Set to null as it's not property-specific
      propertyName: 'General Enquiry' // Default for contact form submissions
    };
    
    // Create the document path with the hierarchical structure - using bookingEnquiries collection
    const docRef = doc(db, 'bookingEnquiries', year);
    
    // Set the document with a nested structure using merge to preserve existing data
    await setDoc(docRef, {
      [month]: {
        [date]: {
          [enquiryId]: dataWithTimestamp
        }
      }
    }, { merge: true });
    
    console.log('Contact enquiry saved successfully with ID:', enquiryId);
    return { success: true, enquiryId };
    
  } catch (error) {
    console.error('Error saving contact enquiry:', error);
    return { success: false, error: error.message };
  }
};
